import Checkbox from 'components/Buttons/CheckboxButton';
import Dropdown from 'components/Input/dropdown/Dropdown';
import MultiSelectInput from 'components/Input/MultiSelect';
import React, { useEffect } from 'react';
import { CheckboxContainer, CheckboxLabel, InputContainer, InputLabel } from 'routes/Configurator/styles';
import utils from 'utils';
import { getDaysOfWeekList, getHoursOptions, minutesOptions } from '../utils';
import Box, { TitleSection } from 'components/Box';

interface IProps {
  enabled?: boolean;
  setEnabled?: Function;
  hour: { label: string; value: string } | null;
  setHour: Function;
  minute: { label: string; value: number } | null;
  setMinute: Function;
  allDays: boolean;
  setAllDays: Function;
  daysOfWeek: { label: string; value: number }[];
  setDaysOfWeek: Function;
  hasBox?: boolean;
}

const CronFrequencySelector = ({
  enabled,
  setEnabled,
  hour,
  setHour,
  minute,
  setMinute,
  allDays,
  setAllDays,
  daysOfWeek,
  setDaysOfWeek,
  hasBox = false,
}: IProps) => {
  const t = utils.intl.useTranslator();

  const daysOfWeekList = getDaysOfWeekList(t);
  const hoursOptions = getHoursOptions();

  useEffect(() => {
    // If all available days are selected, enable alldays
    if (daysOfWeek.length === daysOfWeekList.length && !allDays) {
      setAllDays(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [daysOfWeek]);

  useEffect(() => {
    if (allDays) {
      setDaysOfWeek([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allDays]);
  const content = (
    <>
      <InputContainer>
        <InputLabel> {t('hour')}</InputLabel>
        <Dropdown
          id="hour-dropdown"
          name="hour"
          value={hour}
          onChange={(value) => {
            setHour(value);
          }}
          options={hoursOptions}
          placeholder={t('select_hour')}
          width="200px"
        />
      </InputContainer>
      <InputContainer>
        <InputLabel> {t('minute')}</InputLabel>
        <Dropdown
          id="minute-dropdown"
          name="minute"
          value={minute}
          onChange={(value) => {
            setMinute(value);
          }}
          options={minutesOptions}
          placeholder={t('select_minute')}
          width="200px"
        />
      </InputContainer>
      <InputContainer>
        <InputLabel>{t('daysOfWeek')}</InputLabel>
        <MultiSelectInput
          id="daysOfWeek-select"
          labelledBy="daysOfWeek"
          value={daysOfWeek}
          options={daysOfWeekList}
          onChange={(value: { label: string; value: number }[]) => {
            setDaysOfWeek(value);
          }}
          hasSelectAll={false}
          disabled={allDays}
        />
      </InputContainer>
      <CheckboxContainer paddingBottom={enabled !== undefined ? '14px' : '0px'}>
        <CheckboxLabel>{t('allDays')}</CheckboxLabel>
        <Checkbox
          name="allDays"
          isActive={allDays}
          action={(e) => {
            setAllDays(e);
          }}
        />
      </CheckboxContainer>
      {enabled !== undefined && setEnabled !== undefined && (
        <CheckboxContainer paddingBottom="0px">
          <CheckboxLabel>{t('enabled')}</CheckboxLabel>
          <Checkbox name="enabled" isActive={enabled} action={(e) => setEnabled(e)} />
        </CheckboxContainer>
      )}
    </>
  );
  return (
    <div>
      {hasBox ? (
        <Box title={t('choose_frequency')}>{content}</Box>
      ) : (
        <>
          <InputContainer>
            <TitleSection>{t('choose_frequency')}</TitleSection>
          </InputContainer>
          {content}
        </>
      )}
    </div>
  );
};
export default CronFrequencySelector;
